import { ACHIEVEMENTS_DASHBOARD } from '../../config/constants';
import setContext from '../view/set-context';

const loadAchievementsDashboardPage = () => dispatch => {
  dispatch(setContext(ACHIEVEMENTS_DASHBOARD));
};

export default loadAchievementsDashboardPage;
